import React, {Component} from "react";
import {connect} from 'react-redux';
import FJCommonModal from "../../../common/component/modal/FJCommonModal";
import {FJStockVideoAction} from "../../../redux/action/FJRoot.action";
import FJVideoDetails from "../view/stockVideo/video/FJVideoDetails";
import FJPhotoDetails from "../view/stockVideo/photo/FJPhotoDetails";
import FJCoreConstant from "../../../core/constant/FJCoreConstant";
import FJMedia from "../../../store/FJMedia";
import key from 'keymaster'

class FJStockDetailsModelContainer extends Component {

  constructor(props) {
    super(props);
    this.state = {
      containerWidth: 947,
    }
  }

	_cache = {};

	_updateCache = (data) => {
		const {id, url, keywords} = data;
		this._cache[id] = this._cache[id] || {};
		this._cache[id][url] = url || this._cache[id][url];
		this._cache[id][keywords] = keywords || this._cache[id][keywords];
	};

	_onSearch = (value) => {
		const {sortType, data} = this.props;
		const {onSearchVideo} = this.props;
		switch (data.type) {
			case 'video':
				onSearchVideo(value, sortType, 1);
				break;
		}
	};

	_onVideoSubmit = (id, preSelected, url, options) => {
		this._onSubmit(id, FJCoreConstant.VIDEO, FJMedia.MediaFromType().STOCK, preSelected, url, options);
	};

	_onImageSubmit = (id, preSelected, url, options) => {
		this._onSubmit(id, FJCoreConstant.IMAGE, FJMedia.MediaFromType().UNSPLASH, preSelected, url, options);
	};

	_onSubmit = (id, type, formType, preSelected, url, options) => {
		this.props.toggleStockMedia(id, type, formType, !preSelected, url, options)
	};

	_onShow = () => {
		key.setScope('videoDetail');
	};

	_onCancel = () => {
		const {onCancel, data} = this.props;
		onCancel({type: data.type});
	};

	_onVideoDetailSizeChange = (width) => {
	  this.setState({containerWidth: width});
  };

	render() {
		let {visible, data, mediaList,} = this.props;
		let {containerWidth} = this.state;
		const {id, type, title, url, hotWords, thumbnail, originWidth, originHeight, duration} = data;
    const isAddToLibrary = !!mediaList.find(media => id === media.id);
		return (
			<FJCommonModal
				visible={visible}
				hasOuterCloseBtn
				hasOuterTitle
				title={data.headerTitle}
				onCancel={this._onCancel}
				onShow={this._onShow}
				render={() => {
					switch (type) {
						case 'video':
							return <FJVideoDetails onCancel={this._onCancel}
							                       isAddToLibrary={isAddToLibrary}
							                       title={title}
                                     onViewSizeChange={this._onVideoDetailSizeChange}
							                       thumbnail={thumbnail}
							                       duration={duration}
							                       url={url}
							                       cache={this._cache}
							                       updateCache={this._updateCache}
							                       onSearch={this._onSearch}
							                       onSubmit={this._onVideoSubmit}
							                       hotWords={hotWords}
							                       id={id}
							/>;
						case 'image':
							return <FJPhotoDetails onCancel={this._onCancel}
							                       onSubmit={this._onImageSubmit}
							                       url={url}
							                       originWidth={originWidth}
							                       originHeight={originHeight}
							                       thumbnail={thumbnail}
							                       id={id}
                                     isAddToLibrary={isAddToLibrary}
							                       title={title}
							/>
					}
				}}
				width={`${containerWidth}px`}
			/>
		)
	}

}

const mapStateToProps = function (state) {
	return {
		visible: state.modal.isShowStockDetailsModal,
		sortType: state.stock.searchVideoSortType,
		data: state.modal.stockDetailData,
    mediaList: state.media.mediaList,
	}

}

const mapDispatchToProps = function (dispatch) {
	return {
		onCancel: function (data) {
			dispatch(FJStockVideoAction.hideStockDetailModalAction(data))
		},
		onSearchVideo: function (keywords, sortType, page) {
			dispatch(FJStockVideoAction.searchVideoAction(keywords, sortType, page))
		},
		toggleStockMedia: function (id, type, formType, toggle, url, options) {
			dispatch(FJStockVideoAction.toggleStockMediaAction(id, type, formType, toggle, url, options))
		},
	}

}


export default connect(mapStateToProps, mapDispatchToProps)(FJStockDetailsModelContainer);